// extracted by mini-css-extract-plugin
export default {"text":"v7N6CURX","check":"Y04nmGsn","increase":"ZCz9MUuG"};